'use strict';

var _webviewTitle = require('./webview-title');

var _webviewTitle2 = _interopRequireDefault(_webviewTitle);

var _img = require('./img');

var _img2 = _interopRequireDefault(_img);

var _getInfoFromApp = require('./getInfoFromApp');

var _getInfoFromApp2 = _interopRequireDefault(_getInfoFromApp);

var _viewAndCommunicate = require('./viewAndCommunicate.js');

var _viewAndCommunicate2 = _interopRequireDefault(_viewAndCommunicate);

var _other = require('./other');

var _other2 = _interopRequireDefault(_other);

var _share = require('./share');

var _share2 = _interopRequireDefault(_share);

var _more = require('./more');

var _more2 = _interopRequireDefault(_more);

var _common = require('./lib/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _common2.default.extend(_webviewTitle2.default, _img2.default, _getInfoFromApp2.default, _viewAndCommunicate2.default, _other2.default, _more2.default, _share2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/index.js
// module id = 268
// module chunks = 4